/* src/app/forms/produtos/mercadolivre/meli-item-variation/meli-item-variation.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.data-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;
}
.wizard-steps {
  padding: 8px 16px;
  border-bottom: 1px solid var(--tem-border, #f0f0f0);
}
.step-clickable {
  cursor: pointer;
}
.step-content {
  flex: 1;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  border-bottom: 1px solid var(--tem-border, rgba(0, 0, 0, 0.1215686275));
  margin-bottom: 6px;
  padding: 12px;
}
.field {
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  padding: 10px;
  gap: 10px;
}
.field-action {
  cursor: pointer;
  margin-left: 4px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.field-action:hover {
  color: var(--tem-deep, #1890ff);
}
.spacer {
  flex: 1;
}
.image-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
  max-height: 160px;
  overflow: auto;
}
.image-tags nz-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.atributo-garantia {
  position: relative;
  min-height: 100%;
}
.links {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 4px 10px;
  background: var(--tem-surface-2, rgba(0, 0, 0, 0.03));
  border-radius: 6px;
}
.attrib-extra {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  font-size: var(--tem-fs-sm, 12px);
}
.attrib-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  align-items: stretch;
}
.attrib-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 130px;
  background: var(--tem-surface, #fff);
}
.attrib-card-required {
  border-color: var(--tem-danger, #ff4d4f);
}
.attrib-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.attrib-card-title {
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attrib-card-close {
  cursor: pointer;
  flex-shrink: 0;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.attrib-card-close:hover {
  color: var(--tem-danger, #ff4d4f);
}
.attrib-card-hint {
  font-size: 11px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  min-height: 28px;
  max-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.attrib-card-content {
  margin-top: auto;
}
.multi-field {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.multi-field .left {
  flex: 1 1 65%;
}
.multi-field .right {
  flex: 1 1 35%;
  min-width: 90px;
}
.full {
  width: 100%;
}
.variation-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  padding: 6px;
  align-items: start;
}
@media (max-width: 600px) {
  .variation-grid {
    grid-template-columns: 1fr;
  }
}
.variation-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  background: var(--tem-surface, #fff);
  padding: 12px 16px;
  min-height: 60px;
  cursor: pointer;
  transition: box-shadow 0.3s;
}
.variation-card:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.4);
}
.variation-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.variation-card-title {
  flex: 1;
  font-weight: 500;
  font-size: var(--tem-fs-md, 13px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.variation-card-close {
  cursor: pointer;
  flex-shrink: 0;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.variation-card-close:hover {
  color: var(--tem-danger, #ff4d4f);
}
.no-variation {
  grid-column: 1/-1;
  align-content: center;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  padding: 40px 0;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
/*# sourceMappingURL=meli-item-variation.component.css.map */
